import Api from '@/api/api.js'
import configApi from '@/api/config/_api_config'
import StockApi from '@/api/stock/api_stock.js'

async function clinicalRequest(method, path, data) {
    const access = (await configApi().post('/soins/access', {}, {
        soins_access_scoped: true, timeout: 20000
    })).data
    const token = access && access.data && access.data.access_token
    if (!token) throw new Error('Accès infirmier indisponible.')
    const response = await Api()({
        method, url: path, data,
        med_access_scoped: true, timeout: 20000,
        headers: { 'X-Soins-Access': token }
    })
    return response.data
}

export default {
    myServices() {
        return StockApi().get('/v1/settings/hospital-services/my-assignments')
            .then(response => response.data)
    },
    pipeline() { return clinicalRequest('get', '/v1/nursing/pipeline') },
    pendingCashierItems() { return clinicalRequest('get', '/v1/nursing/pending-cashier-items') },
    reconcileStock() { return clinicalRequest('post', '/v1/care-consumables/reconcile-stock', {}) },
    attachConsumableService(id, serviceId) {
        return clinicalRequest('post', `/v1/care-consumables/${id}/attach-service`, { service_id: serviceId })
    },
    availableBeds(category = 'all', serviceId = '') {
        const unite = serviceId ? '&service_id=' + encodeURIComponent(serviceId) : ''
        return clinicalRequest('get', '/v1/beds/available?category=' + encodeURIComponent(category) + unite)
    },
    bedOccupancy() { return clinicalRequest('get', '/v1/beds/occupancy') },
    cleaningBeds() { return clinicalRequest('get', '/v1/beds/cleaning') },
    markBedReady(bedId) {
        return clinicalRequest('post', `/v1/beds/${bedId}/mark-ready`, { cleaning_confirmed: true })
    },
    assignBed(planId, data) {
        return clinicalRequest('post', `/v1/admissions/${planId}/assign-bed`, data)
    },
    pendingBilling(stayId) {
        return clinicalRequest('get', `/v1/admissions/${stayId}/pending-billing`)
    },
    confirmBilling(stayId) {
        return clinicalRequest('post', `/v1/admissions/${stayId}/confirm-billing`, {})
    },
    discharge(stayId) {
        return clinicalRequest('post', `/v1/admissions/${stayId}/discharge`, { departure_confirmed: true })
    },
    stayForDoctor(consultationId) {
        return clinicalRequest('get', `/v1/admissions/consultations/${consultationId}`)
    },
    planDischarge(stayId, destination) {
        return clinicalRequest('post', `/v1/admissions/${stayId}/plan-discharge`, { destination })
    }
}
